import React from 'react'
import { Tab } from 'semantic-ui-react'
import { setEternalCookie, getCookie } from '@bsd/dashboard-toolkit/utils'

import { DEFAULT_LOCALE, LOCALES } from '../../constants'


class LocalizationField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLocale: getCookie('last_used_locale') || LOCALES[0].code,
    }
  }

  localesWithoutDefault = LOCALES.filter(locale => locale.code !== DEFAULT_LOCALE)

  handleChange = (field, locale, value) => {
    const newValue = { ...this.props.value }
    newValue[locale][field] = value
    this.props.onChange(newValue)
  }

  selectLocale = (e, { activeIndex }) => {
    const locale = this.localesWithoutDefault[activeIndex].code
    setEternalCookie('last_used_locale', locale)
    this.setState({ selectedLocale: locale })
  }

  render() {
    const { localeForm, value } = this.props
    const panes = this.localesWithoutDefault.map((locale, idx) => {
      let localeHasEmptyFields = false
      for (let val of Object.values(value[locale.code])) {
        if (!val) {
          localeHasEmptyFields = true
          break
        }
      }
      return {
        menuItem: {
          key: locale.code,
          index: idx,
          icon: localeHasEmptyFields ? 'exclamation' : null,
          content: locale.code,
        },
        render: () => React.createElement(localeForm, {
          required: locale.default,
          data: value[locale.code],
          onChange: (field) => (value) => {
            this.handleChange(field, locale.code, value)
          },
        }),
      }
    })
    const { selectedLocale } = this.state
    return (
      <div>
        <Tab
          menu={{ secondary: true, pointing: true }}
          panes={panes}
          activeIndex={this.localesWithoutDefault.findIndex(locale => locale.code === selectedLocale)}
          onTabChange={this.selectLocale}
        />
      </div>
    )
  }

}

export default LocalizationField
